import { 
	Home16,
	Tools16,
	Education16,
	CalendarHeatMap16,
	DotMark16,
} from '@carbon/icons';

import systemRoutes from './endpoints/system';
import profileRoutes from './endpoints/profile';
import logRoutes from './endpoints/log';
import tenderRoutes from './endpoints/tender';
import orderRoutes from './endpoints/order';
import chatRoutes from './endpoints/chat';
import clientRoutes from './endpoints/client';
/* import accreditationRoutes from './endpoints/accreditation'; */


export default [
	/* **** */
	{
		path: '/',
		redirect: '/home',
	},
	/* **** */
	{
		path: '/home',
		layout: 'Admin',
		component: 'Home',
		meta: {
			name: 'Монитор',
			icon: Home16,
		},
		menu: true,
	},
	/* **** */
	{
		path: '/home/:day',
		layout: 'Admin',
		component: 'Home',
		meta: {
			name: 'Монитор',
		},
		menu: false,
	},	
	/* **** */
	{
		path: '/calendar',
		layout: 'Admin',
		component: 'Calendar',
		meta: {
			name: 'Тендерный календарь',
			icon: CalendarHeatMap16,
		},
		menu: true,
	},
	/* **** */
	{
		path: '/calendar/:day',
		layout: 'Admin',
		component: 'Calendar',
		meta: {
			name: 'Тендерный календарь',
		},
		menu: false,
	},	
	/* **** */
	...systemRoutes,
	...logRoutes,
	...tenderRoutes,
	...orderRoutes,
	/* ...accreditationRoutes, */
	...chatRoutes,
	...clientRoutes,
	/* **** */
	{
		path: '/academy',
		layout: 'Admin',
		component: 'Academy',
		meta: {
			name: 'Обучающие курсы',
			icon: Education16,
		},
		menu: true,
	},
	/* **** */
	...profileRoutes,
	/* **** */
	/*
	{
		path: '/test457',
		layout: 'Admin',
		component: 'Test',
		meta: {
			name: 'Тестовая страница',
		},
		menu: false,
	},
	*/
	/* **** */
	{
		path: '/special/offers',
		layout: 'Admin',
		component: 'SpecialOffers',
		meta: {
			name: 'Рекламные баннеры',
			icon: DotMark16,
		},
		menu: false,
		permissions: [ 'special_offer_edit' ],
	},
	/* **** */
	{
		path: '/special/offers/courses',
		layout: 'Admin',
		component: 'SpecialOffersCourses',
		meta: {
			name: 'Курсы обучения',
			icon: DotMark16,
		},
		menu: false,
		permissions: [ 'special_offer_edit' ],
	},
	/* **** */
	{
		path: '/auth',
		layout: 'Auth',
		component: 'Login',
	},
	/* **** */
	{
		path: '/register',
		layout: 'Auth',
		component: 'Registration',
	},
	/* **** */
	{
		path: '/regforum',
		redirect: '/register/?s=forum0622',
	},
	/* **** */
	{
		path: '*',
		component: 'NotFound',
	},
	/* **** */
];
